module.exports = __webpack_public_path__ + "static/img/scan.965a1fce.jpeg";